import React, { Component } from 'react';
import { Row, Col, Button, ButtonGroup, Nav, NavItem } from 'react-bootstrap';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Table from './components/Table';
import Form from './components/Form';
import API from '../../services/API';
import Icon from "../../components/Icon";

class Servers extends Component {
    constructor() {
        super();

        this.state = {
            isLoading: false,
            isShowForm: false,
            sortParam: null,
            sortOrder: 1,
            type: 'bidder',
            servers: []
        };

        this.handleAddBtnClick = this.handleAddBtnClick.bind(this);
        this.handleRemoveBtnClick = this.handleRemoveBtnClick.bind(this);
        this.handleFormHide = this.handleFormHide.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handleTabSelect = this.handleTabSelect.bind(this);
    }

    componentDidMount() {
        this.loadServers(this.state.type);
    }

    componentWillUpdate(nextProps, nextState) {
        const { servers, sortParam, sortOrder, type } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(servers, sortParam, sortOrder);

            this.setState({ servers });
        }
    }

    sortReport(servers, sortParam, sortOrder) {
        servers.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    loadServers(type) {
        this.setState({ isLoading: true });

        API.Servers.get(type).then(servers => this.setState({ servers, isLoading: false }));
    }

    handleAddBtnClick() {
        this.setState({ isShowForm: true });
    }

    handleFormHide() {
        this.setState({ isShowForm: false, payoutToUpdate: null });
    }

    handleFormSubmit(server) {
        this.setState({
            isShowForm: false,
            isLoading: true
        });

        API.Servers.save(server).then(() => this.loadServers(this.state.type));
    }

    handleRemoveBtnClick(id) {
        this.setState({ isLoading: true });

        API.Servers.remove(id).then(() => this.loadServers(this.state.type));
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handleTabSelect(type) {
        this.setState({ type });

        this.loadServers(type);
    }

    getForm() {
        if(this.state.isShowForm) {
            return <Form
                onSubmit={this.handleFormSubmit}
                onFormHide={this.handleFormHide} />;
        }
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Servers"/>
                <Row>
                    <Col lg={12}>
                        <ButtonGroup className="pull-right m-b-15">
                            <Button bsStyle="success" onClick={this.handleAddBtnClick}><Icon name="plus"/> Add</Button>
                        </ButtonGroup>
                    </Col>
                </Row>

                <Nav bsStyle="tabs" activeKey={this.state.type} onSelect={this.handleTabSelect}>
                    <NavItem eventKey="bidder" >Bidders</NavItem>
                    <NavItem eventKey="bidder-clk" >Bidders Click</NavItem>
                    <NavItem eventKey="bidder-adk">Bidders ADK</NavItem>
                    <NavItem eventKey="pushapi-eu">Pushapi EU</NavItem>
                    <NavItem eventKey="pushapi-eu-clk">Pushapi EU Click</NavItem>
                    <NavItem eventKey="pushapi-us">Pushapi US</NavItem>
                    <NavItem eventKey="pushapi-us-clk">Pushapi US Click</NavItem>
                    <NavItem eventKey="app">AppServers</NavItem>
                    <NavItem eventKey="ss">SendServers</NavItem>
                    <NavItem eventKey="adk">ADK</NavItem>
                    <NavItem eventKey="adk-EU">ADK EU</NavItem>
                    <NavItem eventKey="adk-US">ADK US</NavItem>
                    <NavItem eventKey="adk-SG">ADK SG</NavItem>
                    <NavItem eventKey="adk-banner-EU">ADK Banner EU</NavItem>

                    <NavItem eventKey="webserver">Webservers</NavItem>
                    <NavItem eventKey="adk-haproxy">ADK HAProxy</NavItem>
                </Nav>

                {this.getForm()}

                <Table servers={this.state.servers} onRemove={this.handleRemoveBtnClick} onSort={this.handleSort}/>
            </Container>
        );
    }
}

export default Servers;



// WEBPACK FOOTER //
// ./src/scenes/Servers/index.js